import React from 'react';
import propTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { FormGroup, FormText, UncontrolledAlert } from 'reactstrap';
import { configureActions } from '../../../../actions/configure.action';
import Datagrid from '../../../UI/Datagrid';
import { Alert } from '../../../UI/Common';

const MP = (props) => {
  const { t, groupId } = props;
  const [typeIds, setTypeIds] = React.useState([]);
  const [sensorTypes, setSensorTypes] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (groupId) {
      setTypeIds([]);
      props.getSensorTypesByReports(groupId);
    }
  }, [groupId]);
  React.useEffect(() => {
    setSensorTypes(props.configure.sensorTypes);
  }, [props.configure.sensorTypes]);
  React.useEffect(() => {
    setLoading(props.isFetching);
  }, [props.isFetching]);
  React.useEffect(() => {
    props.onSelect(typeIds);
  }, [typeIds]);
  const columns = [{ dataField: 'typeName', text: 'Type', sort: true }];
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: typeIds,
    onSelect: handleSelect,
    onSelectAll: handleSelectAll,
  };
  function handleSelect(row, isSelect) {
    if (isSelect) {
      setTypeIds([...typeIds, row.id]);
    } else {
      setTypeIds(typeIds.filter((x) => x !== row.id));
    }
  }

  function handleSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      setTypeIds(ids);
    } else {
      setTypeIds([]);
    }
  }
  if (groupId === undefined) {
    return (
      <FormGroup>
        <FormText>{t('Please choose group above')}</FormText>
      </FormGroup>
    );
  }
  return (
    <>
      {props.invalid ? <Alert.Error text={props.error} /> : null}
      <Datagrid
        datagridProps={{
          keyField: 'id',
          data: sensorTypes,
          loading,
          columns,
          selectRow,
        }}
        noExport
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}

export default withTranslation('app')(
  connect(mapStateToProps, configureActions)(MP),
);

MP.propTypes = {
  onSelect: propTypes.func.isRequired,
};
